'use strict';

import tippy from 'tippy.js';
//import {hideAll} from 'tippy.js';

let tooltipsen = null;
let ticking = false;
let querySelector = '[title]';

//let hjalptipsSnabbval = null;

// ##########################################################################################

const tippyOptions = {

	// Available v2.3+ - If true, HTML can be injected in the title attribute
	allowTitleHTML: true,

	// If true, the tooltip's background fill will be animated (material effect)
	animateFill: false,

	// The type of animation to use
	animation: 'shift-away', // 'shift-toward', 'fade', 'scale', 'perspective'

	// Which element to append the tooltip to
	appendTo: null,	// Obs! Sätts programmatiskt i metoderna nedan!!!!   appendToElement,	//document.body, // Element or Function that returns an element

	// Whether to display the arrow. Disables the animateFill option
	arrow: true,

	// Transforms the arrow element to make it larger, wider, skinnier, offset, etc.
	arrowTransform: 'scaleX(0.8)', // CSS syntax: '', 'scaleX(0.5)', 'scale(2)', 'translateX(5px)' etc.

	// The type of arrow. 'sharp' is a triangle and 'round' is an SVG shape
	arrowType: 'round',	//'sharp', // 'round'

	// The tooltip's Popper instance is not created until it is shown for the first
	// time by default to increase performance
	createPopperInstanceOnInit: false,

	// Delays showing/hiding a tooltip after a trigger event was fired, in ms
	//delay: [200, 2000000], // Number or Array [show, hide] e.g. [100, 500]
	delay: [1000, 200], // Number or Array [show, hide] e.g. [100, 500]

	// How far the tooltip is from its reference element in pixels
	distance: 16,	//10,

	// The transition duration
	duration: [200, 100],	//[350, 300], // Number or Array [show, hide]

	// If true, whenever the title attribute on the reference changes, the tooltip
	// will automatically be updated
	dynamicTitle: false,

	// If true, the tooltip will flip (change its placement) if there is not enough
	// room in the viewport to display it
	flip: true,

	// The behavior of flipping. Use an array of placement strings, such as
	// ['right', 'bottom'] for the tooltip to flip to the bottom from the right
	// if there is not enough room
	flipBehavior: 'flip', // 'flip', 'clockwise', 'counterclockwise', Array

	// Whether to follow the user's mouse cursor or not
	followCursor: false,

	// Upon clicking the reference element, the tooltip will hide.
	// Disable this if you are using it on an input for a focus trigger
	// Use 'persistent' to prevent the tooltip from closing on body OR reference
	// click
	hideOnClick: true, // false, 'persistent'

	// Specifies that the tooltip should have HTML content injected into it.
	// A selector string indicates that a template should be cloned, whereas
	// a DOM element indicates it should be directly appended to the tooltip
	html: false, // 'selector', DOM Element

	// Adds an inertial slingshot effect to the animation. TIP! Use a show duration
	// that is twice as long as hide, such as `duration: [600, 300]`
	inertia: false,

	// If true, the tooltip becomes interactive and won't close when hovered over
	// or clicked
	interactive: false,	// Om false blir element *under* den hovrings-/klickbara.

	// Specifies the size in pixels of the invisible border around an interactive
	// tooltip that prevents it from closing. Useful to prevent the tooltip
	// from closing from clumsy mouse movements
	interactiveBorder: 2,

	// Available v2.2+ - If false, the tooltip won't update its position (or flip)
	// when scrolling
	// ##### Se även 'sticky':
	livePlacement: false,	//true,

	// The maximum width of the tooltip. Add units such as px or rem
	// Avoid exceeding 300px due to mobile devices, or don't specify it at all
	maxWidth: '99999px',	// Betyder "radbryt aldrig" = man måste göra det själv medelst <br> i själva tooltipsvärdet. Då kan man kontrollera lite bättre var det passar.

	// If true, multiple tooltips can be on the page when triggered by clicks
	multiple: false,

	// Offsets the tooltip popper in 2 dimensions. Similar to the distance option,
	// but applies to the parent popper element instead of the tooltip
	offset: 0, // '50, 20' = 50px x-axis offset, 20px y-axis offset

	// Callback invoked when the tooltip fully transitions out
	//onHidden(instance) { },
	onHidden: function(instance) { },

	// Callback invoked when the tooltip begins to transition out
	//onHide(instance) { },
	onHide: function(instance) { },

	// Callback invoked when the tooltip begins to transition in
	//onShow(instance) {
	onShow: function(instance) {
		doljAlla();		// Ja det funkade faktiskt att göra så här, utan att 'self' också försvann  :)
	},

	// Callback invoked when the tooltip has fully transitioned in
	//onShown(instance) { },
	onShown: function(instance) { },

	// If true, data-tippy-* attributes will be disabled for increased performance
	performance: true,

	// The placement of the tooltip in relation to its reference
	placement: 'top', // 'bottom', 'left', 'right', 'top-start', 'top-end', etc.

	// Popper.js options. Allows more control over tooltip positioning and behavior
	popperOptions: {

		modifiers: {
			preventOverflow: {
				// Annars flippas tooltipsen relativt diverse container-elements på sidan bounderies:
				boundariesElement: 'window'	//appendToElement,	//window,
			}
		}
		// Add the following options to make the tooltip not stay stuck within the viewport.
		//modifiers: {
		//	preventOverflow: {
		//		enabled: false
		//	},
		//	hide: {
		//		enabled: false
		//	},
		//},
	},

	// The size of the tooltip
	size: 'regular', // 'small', 'large'

	// If true, the tooltip's position will be updated on each animation frame so
	// the tooltip will stick to its reference element if it moves
	sticky: false,	//true,	//false,

	// Available v2.1+ - CSS selector string used for event delegation
	target: null, // e.g. '.className'

	// The theme, which is applied to the tooltip element as a class name, i.e.
	// 'dark-theme'. Add multiple themes by separating each by a space, such as
	// 'dark custom'
	theme: 'eui',	// 'dark',

	// Changes trigger behavior on touch devices. It will change it from a tap
	// to show and a tap off to hide, to a touch-and-hold to show, and a release
	// to hide
	touchHold: true,

	// The events on the reference element which cause the tooltip to show
	trigger: 'mouseenter', // Ändrat från detta, för att funka bättre (= inte alls!?) på touch-devices: 'mouseenter focus', // 'click', 'manual'

	// Transition duration applied to the Popper element to transition between
	// position updates
	updateDuration: 20000,	//350,

	// The z-index of the popper
	zIndex: 9999
};

// ##########################################################################################

// Merging objects with same properties (sista argumentet har högst "prio", se https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Merging_objects_with_same_properties):
const tippyOptionsHjalpknapp = Object.assign(
	{},	// Till  ett *nytt* object!
	tippyOptions,	// Skriv först över med detta...
	{	// ...sen detta:

		// Endast de som avviker från tooltipsen (tippyOptions):

		appendTo: document.body,

		// Transforms the arrow element to make it larger, wider, skinnier, offset, etc.
		//arrowTransform: 'scale3d(2,1,1)', // CSS syntax: '', 'scaleX(0.5)', 'scale(2)', 'translateX(5px)' etc.

		// Delays showing/hiding a tooltip after a trigger event was fired, in ms
		//delay: [200, 2000000], // Number or Array [show, hide] e.g. [100, 500]
		//delay: [0, 2000000], // Number or Array [show, hide] e.g. [100, 500]
		delay: [200, 500], // Number or Array [show, hide] e.g. [100, 500]

		// How far the tooltip is from its reference element in pixels
		//distance: 24,	//10,

		// The transition duration
		// !!!!!!!!!!!!! Obs! Se kommentar under onHidden nedan!!!!!!!
		//duration: [200, 0],	//[350, 300], // Number or Array [show, hide]
		//duration: [200, 100],	//[350, 300], // Number or Array [show, hide]

		//// If true, the tooltip will flip (change its placement) if there is not enough
		//// room in the viewport to display it
		//flip: false,

		// Specifies that the tooltip should have HTML content injected into it.
		// A selector string indicates that a template should be cloned, whereas
		// a DOM element indicates it should be directly appended to the tooltip
		html: false,	// !!!!!!! OBS! Måste sättas runtime!		//'#hjalp-snabbval',

		// Adds an inertial slingshot effect to the animation. TIP! Use a show duration
		// that is twice as long as hide, such as `duration: [600, 300]`
		inertia: true,

		// If true, the tooltip becomes interactive and won't close when hovered over
		// or clicked
		interactive: true,	// Om false blir element *under* den hovrings-/klickbara.

		// Specifies the size in pixels of the invisible border around an interactive
		// tooltip that prevents it from closing. Useful to prevent the tooltip
		// from closing from clumsy mouse movements
		interactiveBorder: 10,

		// The maximum width of the tooltip. Add units such as px or rem
		// Avoid exceeding 300px due to mobile devices, or don't specify it at all
		maxWidth: '55rem',	// Betyder *inte* "radbryt aldrig", som vanliga tooltips, se ovan.

		// Offsets the tooltip popper in 2 dimensions. Similar to the distance option,
		// but applies to the parent popper element instead of the tooltip
		offset: '-20, 0',	// 0, // '50, 20' = 50px x-axis offset, 20px y-axis offset

		//// Callback invoked when the tooltip begins to transition out
		////onHide(instance) { },
		//onHide: function(instance) { },

		// Callback invoked when the tooltip fully transitions out
		//onHidden(instance) { },
		onHidden: function(instance) {
			// Nu när vi ändrat triggern till hover/focus(/click), på prov flyttar vi inte heller fokus vid stäng:
			//// När hjälptipset visas blir det document.activeElement = fousramen på knappen släcks. När Tippy tipset så fokuseras det element som man klickade på (event.currentTarget typ) och det är knappen. Därför går det inte att i ett tidigare skede än så här sätta focus på textrutan, t.ex. så här direkt i html-koden:
			////@@click="this.document.querySelector('input[name=\x27snabbval\x27]').focus(); @*$event.currentTarget.blur();*@"
			//// Detta faktum leder till denna lösning, vilken gör att knappen fokus-blinkar till lite en kort stund (= duration hide) innan det blir som vi vill. Därför att duration hide satt till 0 ovan.
			//// Sen är det ju inte helt säkert att man *vill* ha fokus i just den rutan. Egentligen kanske där fokus var *innan* knappklicket. Skiter i det nu :)  Måste antagligen i så fall införa egen eventhanterare som körs *innan* Tippy tar hand om eventet och trixa!?
			//document.querySelector('input[name=\x27snabbval\x27]').focus();
		},

		//// Callback invoked when the tooltip begins to transition in
		////onShow(instance) {
		//onShow: function(instance) {
		//	//doljAlla();		// Ja det funkade faktiskt att göra så här, utan att 'self' också försvann  :)
		//},

		//// Callback invoked when the tooltip has fully transitioned in
		////onShown(instance) { },
		//onShown: function(instance) { },

		// The placement of the tooltip in relation to its reference
		placement: 'right-start',	//'bottom', // 'bottom', 'left', 'right', 'top-start', 'top-end', etc.

		//// Popper.js options. Allows more control over tooltip positioning and behavior
		//popperOptions: {

		//	modifiers: {
		//		preventOverflow: {
		//			// Annars flippas tooltipsen relativt diverse container-elements på sidan bounderies:
		//			boundariesElement: 'window'	//appendToElement,	//window,
		//		}
		//	}
		//	// Add the following options to make the tooltip not stay stuck within the viewport.
		//	//modifiers: {
		//	//	preventOverflow: {
		//	//		enabled: false
		//	//	},
		//	//	hide: {
		//	//		enabled: false
		//	//	},
		//	//},
		//},


		// Changes trigger behavior on touch devices. It will change it from a tap
		// to show and a tap off to hide, to a touch-and-hold to show, and a release
		// to hide
		touchHold: false,

		// The events on the reference element which cause the tooltip to show
		trigger: 'click',	//'mouseenter click', // 'mouseenter focus', // 'click', 'manual'
	}
);

// ##########################################################################################

const initiera = function(appendToElement)
{
	console.time('#TIMING: Initiera tooltips');	// Todo: TEMP!!!
	{	// Bara för att få en visuell region i editorn:

		if (!tooltipsen)
		{
			// Bara om initiering *inte* redan skett:

			// Ändra options för detta anrop:
			tippyOptions.appendTo = appendToElement;

			tooltipsen = tippy(querySelector, tippyOptions);

			window.addEventListener('keyup', function () {
				doljAlla();
			}, false);
		}
	}
	console.timeEnd('#TIMING: Initiera tooltips');	// Todo: TEMP!!!
};

const ominitiera = function()
{
	if (tooltipsen)
	{
		// Bara om initiering skett:
		destroyaAlla();

		//console.time('#TIMING: OM-initiera tooltips');	// Todo: TEMP!!!
		{	// Bara för att få en visuell region i editorn:

			tooltipsen = tippy(querySelector, tippyOptions);

		}
		//console.timeEnd('#TIMING: OM-initiera tooltips');	// Todo: TEMP!!!
	}
}

const doljAlla = function()
{
	if (tooltipsen)
	{
		// Bara om initiering skett:

		// Todo: Funkar inte förrän vi uppdaterat Tippy till minst v4.0.0:
		// Ersatt med nyare metod:
		//tippy.hideAll({duration: 0});

		for (const popper of document.querySelectorAll('.tippy-popper'))
		{
			const instance = popper._tippy;

			if (instance.state.visible)
			{
				instance.popperInstance.disableEventListeners();
				instance.hide();
			}
		}
	}
};

const doljAllaNarInnehalletRullas = function (rullningsbartElement)
{
	// Since scroll events can fire at a high rate, the event handler shouldn't execute computationally expensive operations such as DOM modifications. Instead, it is recommended to throttle the event:
	// Bra info: https://css-tricks.com/debouncing-throttling-explained-examples/
	// Obs! Chrome verkar numera hantera detta automagiskt vid scroll. Jag har därför inte kunnat testa/jämföra!

	// Enl metod 'requestAnimationFrame': https://developer.mozilla.org/en-US/docs/Web/Events/scroll
	// Todo: Senare, på andra ställen, anv losah throttle. Bör appliceras även här.
	rullningsbartElement.addEventListener('scroll', function (event) 	//() =>
	{
		if (tooltipsen)
		{
			// Bara om initiering skett:

			if (!ticking)
			{
				// Om requestAnimationFrame inte redan begärts och inväntas:

				// Schedule the function to run at the start of the frame:
				window.requestAnimationFrame(function ()
				{
					doljAlla();
					ticking = false;
				});

				ticking = true;
			}
		}
	}, false);
};

const destroyaAlla = function()
{
	if (tooltipsen)
	{
		// Bara om initiering skett:
		tooltipsen.destroyAll();
	}
}


// ##########################################################################################

// Några olika former av exports: https://stackoverflow.com/questions/44006369/idiomatic-revealing-module-pattern-for-es6
// Om export: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
// Todo: Inte säker på att detta är smartaste sättet att göra en named export (= tvinga importern att använda ett specifikt namn/namespace ('ssoTooltip') och sedan konsumera members med window.ssoTooltip.xxx):

const ssoTooltips = {
	// Properties:
	tooltipsen,				// Todo: Ehh.. Denna följer inte med i importen, då den sätts *efter* det att man gjort importen. Denna är därför alltid null!
	tippyOptions,
	tippyOptionsHjalpknapp,

	// Methods:
	initiera,
	ominitiera,
	doljAlla,
	doljAllaNarInnehalletRullas,
	destroyaAlla,
};

export { ssoTooltips };
